import { map, throttle } from 'rxjs/operators';
import { combineLatest, interval } from 'rxjs';
import { Component } from '@angular/core';

import { DoodModalModel } from '@core/models/modal.model';
import { DoodModalConfig } from '@core/models/marketplace.model';

import { ModalStoreSelector } from '@common/selectors/modal.selector';
import { ContentStoreSelector } from '@common/selectors/content.selector';
import { ModalBackHistoryService } from '@core/services/modal-back-history/modal-back-history.service';

@Component({
  selector: 'app-modals-container',
  templateUrl: './modals-container.component.html',
  standalone: false,
})
export class ModalsContainerComponent {
  // Short throttle to merge rapid modal open/close actions (e.g. upselling → product modal) without introducing visible delay
  // TODO: Once the product add modal is refactored, try removing the throttle (currently, logic inside the product-add modal seems to temporarily freeze the app)
  openedModals$ = this.modalSelector.selectModals.pipe(
    throttle(() => interval(100), { leading: true, trailing: true }),
  );
  modalConfigs$ = this.contentSelector.selectModals;
  modalList$ = combineLatest([this.openedModals$, this.modalConfigs$]).pipe(map(this.joinItems));

  constructor(
    private modalSelector: ModalStoreSelector,
    private contentSelector: ContentStoreSelector,
    _modalBackHistory: ModalBackHistoryService,
  ) {}

  joinItems([modals, modalConfigs]: [DoodModalModel[], DoodModalConfig[]]): DoodModalConfig[] {
    const modalConfigsToDisplay = [];
    for (const modal of modals) {
      const modalConfig = modalConfigs.find(m => modal.handle === m.handle);
      if (!modalConfig) {
        console.error('Modal not found ' + modal.handle);
        continue;
      }
      modalConfigsToDisplay.push({
        ...modalConfig,
        // Runtime open() data first, then content-builder shell props override stale preview state.
        data: { ...(modal.data ?? {}), ...(modalConfig.data ?? {}) },
      });
    }
    return modalConfigsToDisplay;
  }

  getModalData(modal: DoodModalConfig): Record<string, unknown> {
    return { ...(modal.data ?? {}), handle: modal.handle };
  }

  itemTrackBy(_index: number, modal: DoodModalConfig): string {
    return modal.handle;
  }
}
